<template>
    <div
        class="el-cal-item"
        :style="{ borderColor: colorLuminance(background, -0.2), background }"
    >
        <div class="el-cal-item__title">
            <div
                class="el-cal-item__title-text"
                v-if="booking.start && booking.end"
            >
                {{ booking.start.format('HH:mm') }} -
                {{ booking.end.format('HH:mm') }}
            </div>
            <div class="el-cal-item__title-text" v-if="booking.actor">
                <p>
                    {{ trans('form.label.bookingRef') }} :
                    {{ booking.actor.BookingReference }}
                </p>
                <p>
                    {{ packageGroupItems.length }}
                    {{ trans('data.label.items') }}
                </p>
            </div>
        </div>
        <div
            class="el-cal-item__resources-icon-list"
            v-if="booking.requestedResources"
        >
            <ul class="resources-icon-list inline-block">
                <li
                    v-if="booking.requestedResources.includes('FORKLIFT')"
                    class="resource-icon resource-icon__transporter"
                ></li>
                <li
                    v-if="booking.requestedResources.includes('TRUCK')"
                    class="resource-icon resource-icon__truck"
                ></li>
                <li
                    v-if="booking.requestedResources.includes('MANPOWER')"
                    class="resource-icon resource-icon__team"
                ></li>
                <li
                    v-if="booking.requestedResources.includes('CRANE')"
                    class="resource-icon resource-icon__crane"
                ></li>
                <li
                    v-if="booking.requestedResources.includes('TOOLS')"
                    class="resource-icon resource-icon__tools"
                ></li>
            </ul>
        </div>
        <div class="tippy-popper" ref="tooltip">
            <v-card class="white--text v-card-round" width="430">
                <v-card-title
                    primary-title
                    :style="`background-color : ${popoverBackground}`"
                >
                    <v-layout>
                        <v-flex xs9>
                            <div>
                                <div class="subheading mb-3">
                                    {{ booking.actor.BookingReference }}
                                </div>
                                <div class="body-2 font-weight-medium">
                                    {{ trans('table.column.status') }}:
                                    {{
                                        trans(
                                            `status.${
                                                booking.route.StatusDescription
                                            }`
                                        ) || booking.route.StatusDescription
                                    }}<span class="caption"></span>
                                </div>
                            </div>
                        </v-flex>
                        <v-flex xs3 justify-end>
                            <div>
                                <div class="mb-3 body-2">
                                    <v-layout justify-space-around>
                                        <v-btn @click="editBooking" icon small>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn
                                            @click="deleteBooking"
                                            icon
                                            small
                                        >
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                        <v-btn @click="tippy.hide()" icon small>
                                            <v-icon>clear</v-icon>
                                        </v-btn>
                                    </v-layout>
                                </div>
                                <div class="body-2">
                                    <!-- {{ packageGroupItems.length }}-->
                                    <!-- {{ trans('data.label.items') }}-->
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-card-title>
                <v-card-text class="pa-3 white black--text">
                    <v-layout>
                        <v-flex xs6>
                            <v-icon class="mr-2">event_note</v-icon>
                            <div class="body-2">
                                {{ booking.start.format('YYYY-MM-DD') }}
                            </div>
                        </v-flex>
                        <v-flex xs6>
                            <v-icon class="mr-2">schedule</v-icon>
                            <div class="body-2">
                                {{ booking.start.format('HH:mm') }} -
                                {{ booking.end.format('HH:mm') }}
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout class="mt-3">
                        <v-flex xs3>
                            <div>
                                <div class="caption">
                                    {{ trans('table.column.destination') }}
                                </div>
                                <div class="caption">
                                    {{ trans('text.unloadingArea') }}
                                </div>
                                <div class="caption">
                                    {{ trans('table.label.recipient') }}
                                </div>
                                <div class="caption">
                                    {{ trans('form.label.route') }}
                                </div>
                                <div class="caption">
                                    {{ trans('text.vehicle') }}
                                </div>
                                <div class="caption">
                                    {{ trans('text.driver') }}
                                </div>
                            </div>
                        </v-flex>
                        <v-flex xs9>
                            <div>
                                <div class="caption">
                                    : {{ destinationContainer.Description }}
                                </div>
                                <div class="caption">
                                    :
                                    {{
                                        booking.actor.AccessSets[0]
                                            .UnloadingArea
                                    }}
                                </div>
                                <div class="caption">
                                    :
                                    {{
                                        booking.actor.AccessSets[0]
                                            .RecipientName
                                    }}
                                </div>
                                <div class="caption">
                                    : {{ booking.route.Reference }}
                                </div>
                                <div class="caption">
                                    : {{ booking.route.VehicleDescription }}
                                </div>
                                <div class="caption">
                                    : {{ booking.route.DriverUserFullName }}
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import tippy from 'tippy.js'

export default {
    name: 'route-planner-milkrun-event',

    props: {
        booking: {
            type: Object,
            default: () => {},
        },

        containers: {
            type: Array,
            default: () => {},
        },

        trans: {
            default: () => this.$t,
        },

        route: {
            default() {
                return []
            },
        },

        element: {
            type: Object,
            default: () => {},
        },
    },

    computed: {
        background() {
            if (this.route.BLCRouteID === this.booking.routeId) {
                return '#02006c'
            }

            if (this.booking.route.StatusDescription === 'DELIVERY_CONFIRMED') {
                return '#67c23a'
            }

            if (
                this.booking.route.StatusDescription ===
                'DELIVERY_PARTIALLY_CONFIRMED'
            ) {
                return '#e0e254'
            }

            if (this.booking.route.StatusDescription === 'DELIVERY_COMPLETE') {
                return '#236B66'
            }

            if (this.booking.route.StatusDescription === 'DELIVERY_PARTIAL') {
                return '#f9a825'
            }

            return '#00b4ff'
        },

        popoverBackground() {
            if (this.booking.route.StatusDescription === 'DELIVERY_CONFIRMED') {
                return '#67c23a'
            }

            if (
                this.booking.route.StatusDescription ===
                'DELIVERY_PARTIALLY_CONFIRMED'
            ) {
                return '#e0e254'
            }

            if (this.booking.route.StatusDescription === 'DELIVERY_COMPLETE') {
                return '#236B66'
            }

            if (this.booking.route.StatusDescription === 'DELIVERY_PARTIAL') {
                return '#f9a825'
            }

            return '#00b4ff'
        },

        packageGroupItems() {
            return _.flatMap(this.booking.actor.PackageGroups, 'PackageItems')
        },

        destinationContainer() {
            return _.find(this.containers, {
                ContainerID: this.booking.actor.AccessSets[0]
                    .DestinationContainerID,
            })
        },
    },

    mounted() {
        // tippy('.tippy', {
        //     trigger: 'mouseenter',
        //     onShow(tip) {
        //         tip.set({ trigger: 'click' })
        //     },
        //     onHide(tip) {
        //         tip.set({ trigger: 'mouseenter' })
        //     },
        // })

        this.tippy = tippy.one(this.element.get(), {
            arrow: true,
            arrowTransform: 'scale(1.2)',
            html: this.$refs.tooltip.firstChild,
            interactive: true,
            livePlacement: true,
            delay: 100,
            trigger: 'click',
        })

        this.$once('hook:beforeDestroy', () => {
            this.tippy.destroy()
        })
    },

    methods: {
        colorLuminance(hex, lum) {
            // validate hex string
            hex = String(hex).replace(/[^0-9a-f]/gi, '')
            if (hex.length < 6) {
                hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]
            }
            lum = lum || 0

            // convert to decimal and change luminosity
            var rgb = '#',
                c,
                i
            for (i = 0; i < 3; i++) {
                c = parseInt(hex.substr(i * 2, 2), 16)
                c = Math.round(
                    Math.min(Math.max(0, c + c * lum), 255)
                ).toString(16)
                rgb += ('00' + c).substr(c.length)
            }

            return rgb
        },

        deleteBooking() {
            this.tippy.hide()
            this.$emit('delete-booking', this.booking)
        },

        editBooking() {
            this.tippy.hide()
            this.$emit('edit-booking', this.booking)
        },
    },
}
</script>
<style>
.v-card-round {
    border-radius: 10px;
}
.tippy-tooltip {
    color: inherit !important;
    font-size: inherit !important;
    padding: 0 !important;
    max-width: inherit !important;
    text-align: inherit !important;
    background-color: transparent !important;
}
.tippy-popper[x-placement^='top'] .tippy-arrow {
    border-top-color: #eeeeee !important;
}
.tippy-popper[x-placement^='bottom'] .tippy-arrow {
    border-bottom-color: #eeeeee !important;
}
.tippy-popper[x-placement^='left'] .tippy-arrow {
    border-left-color: #eeeeee !important;
}
.tippy-popper[x-placement^='right'] .tippy-arrow {
    border-right-color: #eeeeee !important;
}
</style>
